"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForestsRejuvenationEffectHandler = exports.ForestsRejuvenationEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class ForestsRejuvenationEffectArgs {
    constructor(healthIncrease) {
        this.healthIncrease = healthIncrease;
        this.__type = EffectType_1.EffectType.ForestsRejuvenation;
        this.__typeName = "ForestsRejuvenation";
        this.name = "Forest's Rejuvination";
        this.harmful = false;
    }
}
exports.ForestsRejuvenationEffectArgs = ForestsRejuvenationEffectArgs;
let ForestsRejuvenationEffectHandler = class ForestsRejuvenationEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectId = container.applyBuff({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Health, state.args.healthIncrease),
            duration: Duration_1.Duration.Permanent,
        });
    }
    remove(sequence, container, state) {
        container.cancelEffect(sequence, state.meta.effectId);
    }
};
ForestsRejuvenationEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.ForestsRejuvenation)
], ForestsRejuvenationEffectHandler);
exports.ForestsRejuvenationEffectHandler = ForestsRejuvenationEffectHandler;
